import { Component, Input, OnDestroy, OnInit } from "@angular/core";

@Component({
  selector: "brother-attribution-request-row-header",
  templateUrl: "./brother-attribution-request-row-header.component.html",
  styleUrls: [
    "../brother-attribution-request-row/brother-attribution-request-row.component.scss",
    "./brother-attribution-request-row-header.component.scss",
  ],
})
export class BrotherAttributionRequestRowHeader {
  public chanichProperties = {
    lastName: "שם משפחה",
    firstName: "שם פרטי",
    israeliId: "ת.ז",
    address: "כתובת",
    nest: "קן",
    layer: "שכבה",
  };
  @Input("indentToScrollBar") public indentToScrollBar: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/admin/brothers-attribution/brother-attribution-search-results/brother-attribution-request-row-header/brother-attribution-request-row-header.component.ts